import React, { useState } from 'react'
import { IoMenu } from 'react-icons/io5'
import userImage from '../assets/user.png'
import Avatar from '../ui/comp/Avatar'
import { RiNotification4Line } from "react-icons/ri";
import { FiSettings } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { AiOutlineDashboard } from 'react-icons/ai';
import { MdLogout } from 'react-icons/md';
import { useUser } from '../hooks/useUser';
import { displayImage } from '../utils/config';

function Header({ callback }) {

    const [isOpen, setIsOpen] = useState(false);

    const { data: user } = useUser();

    return (
        <div className='w-full bg-white py-3 px-6 relative'>

            {isOpen && (
                <div className="absolute right-6 top-[68px] z-50">
                    <StackProfile callback={() => setIsOpen(false)} />
                </div>
            )}

            <div className="flex justify-between items-center">
                <button onClick={() => callback()}>
                    <IoMenu size={30} />
                </button>


                {/* Avatar and other */}
                <div className='flex items-center gap-6'>
                    {/* Settings */}
                    <div>
                        <button className='text-gray-600'>
                            <FiSettings size={20} />
                        </button>
                    </div>


                    {/* Notifications */}
                    <div>
                        <button className='text-gray-600'>
                            <RiNotification4Line size={20} />
                        </button>
                    </div>

                    {/* Avatar and name */}
                    <button className="inline-flex gap-3 items-center cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
                        <Avatar
                            size={"md"}
                            rounded={true}
                            src={user?.display_picture !== "" ? displayImage(user?.display_picture) : userImage}
                        />
                        <div className="hidden md:block -space-y-1">
                            <h1 className='font-bold text-[15px]'>{`${user?.firstname || ""} ${user?.lastname || ""}`}</h1>
                            <p className='text-gray-500 text-xs capitalize text-left'>{user?.role || ""}</p>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Header

const stackItems = [
    {
        title: "Dashboard",
        link: "/",
        icon: <AiOutlineDashboard size={22} />
    },
    {
        title: "Edit Profile",
        link: "/settings",
        icon: <FiSettings size={22} />
    },
    {
        title: "Log out",
        link: "/settings",
        icon: <MdLogout size={22} />
    },
]


function StackProfile({ callback }) {
    return (
        <div className='bg-white py-1 shadow-lg shadow-gray-200/30 rounded-md w-52'>
            <ul className="flex flex-col">
                {stackItems.map((menu, i) => (
                    <li className="py-2 px-5 text-gray-500 hover:text-green-600 transition delay-100 hover:bg-gray-200/30">
                        <Link onClick={() => callback()} to={menu.link} className='flex items-center gap-2.5 text-sm font-medium'>
                            {menu.icon}
                            {menu.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}